import styled from 'styled-components'

const MarketStyled = styled.div`
  .title-container {
    margin-top: 64px;

    .title {
      font-size: 32px;
      line-height: 26px;

      margin-bottom: 12px;
    }
  }
`

export default MarketStyled
